<template>
  <div class="cancel-page">
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <!-- <cancelCardMember ref="member" :mobile="cardMobile" @handleChange="memberChange"></cancelCardMember> -->
          <!-- <div class="head-img" v-if="!form.id">
            <div class="head_avater flex-row">
              <div class="top-img">
                <img :src="userInfo.headImgUrl ? userInfo.headImgUrl : headImgUrl" alt="" style="width: 50px;height: 50px;border-radius: 50%;">
              </div>
              <div class="ml10">
                  <div class="mb10">{{userInfo.nickName}}</div>
                  <div class="flex-row">
                    <div class="color666">{{userInfo.mobile ? userInfo.mobile : userInfo.idCardNo}}</div>
                    <div class="color666 ml30">可用余额： <span class="moneys">￥{{userInfo.walletAmount}}</span></div>
                  </div>
              </div>
            </div>
          </div> -->
          <div class="member-msg" v-if="!form.id">
            <div class="member-border">
              <el-avatar shape="circle" v-if="userInfo.headImgUrl" :src="userInfo.headImgUrl"></el-avatar>
              <el-avatar shape="circle" v-else :src="headerImg"></el-avatar>
              <div class="rows member-box">
                <p>{{ userInfo.nickName }}</p>
                <div class="flex-row mt5">
                  <p class="mobile">{{ userInfo.mobile ? '手机号码:' : '身份证号码:'}} {{ userInfo.mobile ? userInfo.mobile : userInfo.idCardNo}}</p>
                  <p>可用余额: <span class="fontSize18">￥{{ userInfo.walletAmount }}</span></p>
                  <p class="ml20">可用积分: <span class="fontSize18">{{ userInfo.integralAmount }}</span></p>
                </div>
              </div>
            </div>
          </div>
          <el-form
            ref="form"
            :model="form"
            class="plr24 mt20"
            label-width="120px"
            label-position="left"
          >
            <el-form-item
              ref="walletAmount"
              label="账户本金："
              prop="walletAmount"
              class="flex-row"
            >
              <p>{{list.baseAmount}}</p>
            </el-form-item>
            <el-form-item
              ref="giveAmount"
              label="账户赠金："
              prop="giveAmount"
              class="flex-row"
            >
              <p>{{list.giveAmount}}</p>
            </el-form-item>
            <el-form-item label="退款类型：" prop="refundReasonType">
                <el-radio-group v-model="form.refundReasonType">
                  <el-radio label="customerRefund">客户退款</el-radio>
                  <el-radio label="optFault">操作失误</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
              ref="walletAmount"
              label="提现金额："
              prop="walletAmount"
              :rules="$rules.isMoney"
              class="flex-row"
            >
              <el-input v-model.trim="form.walletAmount" placeholder="请输入金额" maxlength="8" />
            </el-form-item>
            <el-form-item
              ref="giveAmount"
              label="扣除赠金："
              prop="giveAmount"
              class="flex-row"
              :rules="$rules.isMoney"
            >
              <el-input v-model.trim="form.giveAmount" class="input" placeholder="请输入金额" maxlength="8" />
            </el-form-item>
            <el-form-item
              ref="giveAmount"
              label="备注："
              prop="giveAmount"
              class="flex-row"
              :rules="$rules.isMoney"
            >
              <el-input v-model="form.remark" type="textarea" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="foot-msg padding-no">
          <p class="infos">温馨提示:</p>
          <p>1.支持余额部分提现;</p>
          <p>2.赠送金额如果想回收，可以相应给会员扣减;</p>
        </div>
        <div class="drawer-footer">
          <!-- <div class="back el-icon-back" @click="back"></div> -->
          <div class="btns pr24 pb10">
            <div class="mr50 flex-row">
              <p>
                提现：
                <span class="money">￥{{ form.walletAmount ? form.walletAmount : 0 }}</span>
              </p>
              <p class="ml30">
                扣除赠金：<span class="money">￥{{form.giveAmount || 0}}</span>
              </p>
            </div>
            <el-button type="primary" @click="configCancelCard">确定提现</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <payDialog
      title="会员销卡效验"
      :bizType="'pay'"
      :hide="dialogHide"
      :oid="''"
      :memberId="form.memberId"
      :price="Number(form.walletAmount)"
      :type="'cancelCard'"
      :mobile="userInfo.mobile"
      :giveAmount="form.giveAmount"
      @changeDialog="savePay"
    ></payDialog>
    <withdrawal-card ref="withdrawalForm" @handleChange="withdrawalBack"></withdrawal-card>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import cancelCardMember from "../../components/cancelCard-member";
import payDialog from "../../components/pay-dialog";
import drawer from "../../../components/common/drawer";
import withdrawalCard from "../../components/withdrawal-card.vue";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { drawer, payDialog, cancelCardMember, withdrawalCard },
  data() {
    return {
      radio: 0,
      addEditShow: false,
      addEditTitle: "会员销卡",
      dialogHide: false,
      paySuccessHide: false,
      textarea: "",
      form: {
        walletAmount: null,
        memberId: "",
        remark: ""
      },
      cardMobile: "",
      memberForm: {},
      list: {},
      memberBgHide: false,
      cancelMobile: "",
      moneys: "",
      payWayForm: {},
      userInfo: {},
      headerImg: require("../../../assets/images/headerImg.png"),
    };
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.$on("set", function(item) {
        Object.assign(this.$data, this.$options.data());
        if (item) {
          this.cardMobile = item;
          this.getMemberInfo();
        } else {
            this.cardMobile = "";
        }
        this.addEditShow = true;
      });
    },
    getMemberInfo () {
      this.$api.get(this.$url.member.search, {
        keyword: this.cardMobile
      })
      .then(res => {
        if (res) {
          console.log(res);
          this.userInfo = res.memberList[0] || {};
          this.list = res.memberList[0] || {};
          this.form.memberId = this.list.id;
          this.moneys = this.list.walletAmount;
        }
      })
    },
    back() {
      this.$refs['form'].resetFields();
      this.cardMobile = "";
      this.$refs.member.clearMember()
      this.$refs.member.handleInputHide();
      this.addEditShow = false;
    },
    handleChangeDrawer(val) {
      this.addEditShow = false;
    },
    handleClose() {
      this.$router.push(`/collectMoney/center`);
    },
    gotoOrderInfo() {
      this.$router.push("/orderInfo");
    },
    gotoProductFootBath() {
      this.$router.push(`/collectMoney/center`);
    },
    handleInputHide() {
      this.memberBgHide = false;
      this.$refs.member.handleInputHide();
      this.form.memberId = "";
    },
    memberChange(value) {
      console.log(value);
      if (value != "") {
        this.memberBgHide = true;
        this.list = value;
        this.form.memberId = value.id;
        this.moneys = value.walletAmount;
      } else {
        this.form.memberId = "";
        this.moneys = "";
      }
    },
    configCancelCard() {
      this.form.walletAmount = this.form.walletAmount ? Number(this.form.walletAmount) : '';
      this.list.baseAmount = this.list.baseAmount ? Number(this.list.baseAmount) : 0;
      if (this.form.memberId == "") {
        this.$message.warning("请选择会员");
        return false;
      } else if (!this.form.walletAmount && !this.form.giveAmount) {
        this.$message.warning("请输入金额");
        return false;
      } else if (this.form.walletAmount == 0 && this.form.giveAmount == 0) {
        this.$message.warning("请输入金额");
        return false;
      } else if (this.form.walletAmount > this.list.baseAmount) {
        
        this.$message.warning("提现金额不能大于会员卡余额");
        return false;
      } else if (Number(this.form.giveAmount) > Number(this.list.giveAmount)) {
        this.$message.warning("扣除赠金不能大于账户赠金");
        return false;
      }
      if (!this.form.refundReasonType) {
        this.$message.warning("请选择退款类型");
        return false;
      }
      if (!this.form.remark) {
        this.$message.warning("请输入备注");
        return false;
      }
      console.log(this.form);
      this.$refs.form.validate(valid => {
        if (valid) {
          this.dialogHide = true;
        }
      });
    },
    paymentChange(org) {
      this.payWayForm = org;
    },
    savePay(value) {
      if (value != "") {
        let arr = {}
        if (this.form.giveAmount) {
          arr = {
            remark: this.form.remark,
            payCheckType: value.payCheckType,
            verifyCode: value.verifyCode,
            memberId: this.form.memberId,
            amount: this.form.walletAmount==""?0:this.form.walletAmount,
            payCode: this.payWayForm.payCode,
            giveAmount: this.form.giveAmount,
            refundReasonType: this.form.refundReasonType,
          }
        } else {
          arr = {
            remark: this.form.remark,
            payCheckType: value.payCheckType,
            verifyCode: value.verifyCode,
            memberId: this.form.memberId,
            amount: this.form.walletAmount==""?0:this.form.walletAmount,
            payCode: this.payWayForm.payCode,
            refundReasonType: this.form.refundReasonType,
          }
        }
        this.$api.post(this.$url.companyRefund.withdraw, JSON.stringify(arr)).then(res => {
            if (res) {
              this.$refs.withdrawalForm.$emit("set", this.form.walletAmount);
              
            }
          });
      } else {
        this.dialogHide = false;
      }
    },
    withdrawalBack () {
      this.dialogHide = false;
      this.addEditShow = false;
      this.$refs['form'].resetFields();
      this.cardMobile = "";
      this.$emit("handleChangeCard", true);
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  padding: 0;

}
/deep/ .el-form-item__content {
  margin-left: 0 !important;
}
.padding-no {
  padding: 10px 20px 0;
}
.btns {
  display: flex;
  align-items: center;
  text-align: left;
  .money {
    font-size: 1rem !important;
    color: @money;
  }
}

.foot-msg {
  background: #FBFBFC;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  margin: 60px 24px 0;
  color: #999;
  p {
    margin-bottom: 10px;
  }
  .infos {
    color: #ff892a;
    margin-bottom: 20px;
  }
}
.member-msg {
  padding: 16px 16px 0;
  .member-border {
    width: 100%;
    background-size: 100% 100%;
    color: white;
    display: flex;
    align-items: center;
    border-radius: 10px;
    padding: 12px 15px;
    background: #3388ff;
    box-sizing: border-box;
    .member-box {
      margin-left: 10px;
      .mobile {
        line-height: 1.6;
        margin-right: 20px;
      }
    }
  }
}
</style>
